import { lessonActionTypes } from './Constants';

const initialState = {
	lesson: {},
	loading: true,
	error: {},
	showSuccessFeedback: false,
};

export default function lessonReducer(state = initialState, action) {
	const { type, payload } = action;
	const { data, error, show } = payload || {};

	switch (type) {
		case lessonActionTypes.GET_LESSON_DETAILS_REQUEST:
		case lessonActionTypes.GET_SCHEDULED_LESSON_STUDENTS_REQUEST:
		case lessonActionTypes.MANAGE_STUDENT_STATUS_REQUEST:
			return {
				...state,
				loading: true,
			};

		case lessonActionTypes.GET_LESSON_DETAILS_SUCCESS:
			return {
				...state,
				lesson: data,
				loading: false,
			};

		case lessonActionTypes.GET_LESSON_DETAILS_ERROR:
		case lessonActionTypes.GET_SCHEDULED_LESSON_STUDENTS_ERROR:
		case lessonActionTypes.MANAGE_STUDENT_STATUS_ERROR:
			return {
				...state,
				error,
				loading: false,
			};

		case lessonActionTypes.SHOW_SUCCESS_FEEDBACK:
			return {
				...state,
				showSuccessFeedback: show,
			};

		case lessonActionTypes.GET_SCHEDULED_LESSON_STUDENTS_SUCCESS:
			return {
				...state,
				students: data,
				loading: false,
			};

		case lessonActionTypes.MANAGE_STUDENT_STATUS_SUCCESS:
			return {
				...state,
				loading: false,
			};

		default:
			return state;
	}
}
